// Footer.js
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,useTheme
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  const theme = useTheme();
  //const isDark = theme.palette.mode === 'dark';
  return (
    <Box sx={{backgroundColor: theme.palette.background.paper , pt: 6, pb: 2,  }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="space-between">
          {/* Left Section */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" gap={1}>
              <img src="/logo.svg" alt="Logo" style={{ height: 50 }} />
              <Box display="flex" flexDirection="column" lineHeight={1}>
                <Typography variant="h5" sx={{ fontWeight: 600, fontSize: '1.6rem', color: theme.palette.text.primary }}>
                  INTRINSIC
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.75rem', color: theme.palette.text.primary, letterSpacing : 1}}>
                  CLINICAL SYSTEMS
                </Typography>
              </Box>
            </Box>
            <Box mt={2}>
            <Link
              href="https://www.linkedin.com/company/intrinsic-clinical-systems/"
              target="_blank"
              underline="hover"
              color="inherit"
              display="flex"
              alignItems="center"
            >
              <LinkedInIcon fontSize="small" sx={{ mr: 1 }} />
              Visit Us on LinkedIn
            </Link>
            </Box>
          </Grid>

          {/* Right Section */}
          <Grid item xs={12} md={7}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Products
                </Typography>
                <Link href="/ctms" underline="hover" display="block">CTMS</Link>
                <Link href="/insights-rm" underline="hover" display="block">Insights RM</Link>
                <Link href="/informer" underline="hover" display="block">Informer</Link>
                <Link href ="/Professional-Services" underline="hover" display="block">Professional Services</Link>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Resources
                </Typography>
                <Link href="/articles" underline="hover" display="block">Articles</Link>
                <Link href="/videos" underline="hover" display="block">Videos</Link>
                <Link href="/conference" underline="hover" display="block">Conference</Link>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Company
                </Typography>
                <Link href="/about" underline="hover" display="block">About</Link>
                <Link href="/leadership" underline="hover" display="block">Leadership</Link>
                <Link href="/careers" underline="hover" display="block">Careers</Link>
                <Link href="/contact" underline="hover" display="block">Contact Us</Link>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4 }} />

        {/* Bottom Text */}
        <Box display="flex" justifyContent="space-between" flexWrap="wrap">
          <Typography variant="body2" color="textSecondary">
            © 2025 Intrinsic Clinical Systems
          </Typography>
          <Link href="/privacy-policy" underline="hover" variant="body2">
            Privacy Policy
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
